import { useState } from 'react';
import { CardTypeEnum, MultiCard, Pagination } from '@tryhackme/thm-ui-components';
import { StyledLoading, StyledLoadingPagination, StyledNoItemsText, StyledTabPaper } from 'src/features/public-profile/public-profile.styles';
import { PublicProfileRoom } from 'src/common/interfaces/public-profile';
import { RoomsTabProps } from './rooms-tab.types';
import { StyledRoomsGrid } from './rooms-tab.styles';
export const RoomsTab = ({
  userId,
  useRoomsHook,
  emptyMessage
}: RoomsTabProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const {
    rooms,
    isLoading,
    totalRooms = 0,
    totalPages = 0,
    refetch
  } = useRoomsHook(userId, currentPage);
  const handlePageChange = async (pageNumber: number) => {
    setCurrentPage(pageNumber);
    await refetch();
  };
  if (isLoading) {
    return <StyledTabPaper withoutBg data-testid="loading">
        <StyledLoading />
        <StyledLoadingPagination>
          <StyledLoading width="24.4rem" height="3.6rem" />
          <StyledLoading width="30rem" height="1.4rem" />
        </StyledLoadingPagination>
      </StyledTabPaper>;
  }
  if (!totalRooms) {
    return <StyledTabPaper>
        <StyledNoItemsText>{emptyMessage}</StyledNoItemsText>
      </StyledTabPaper>;
  }
  return <StyledTabPaper withoutBg data-sentry-element="StyledTabPaper" data-sentry-component="RoomsTab" data-sentry-source-file="rooms-tab.tsx">
      {rooms && <>
          <StyledRoomsGrid gridTemplateColumns="repeat(auto-fill, minmax(280px, 1fr))" gap="2.4rem">
            {rooms.map((room: PublicProfileRoom) => <MultiCard key={room.code} code={room.code} title={room.title} description={room.description} imageProps={{
          src: room.imageURL,
          alt: room.title
        }} difficulty={room.difficulty} cardType={CardTypeEnum.ROOM} roomType={room.type} freeToUse={room.freeToUse} url={`/room/${room.code}`} />)}
          </StyledRoomsGrid>
          {totalPages > 1 &&
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      <Pagination totalPages={totalPages} selectedPage={currentPage} onChange={handlePageChange} />}
        </>}
    </StyledTabPaper>;
};